export const STORAGE_KEY = "shudder-archive";
export const MOVIE_KEY = "they-are-called-films";
export const SORT_KEY = "time-for-order";

export const ONLY_SEEN_KEY = "watch-the-unwatched";
export const ONLY_FAVORITES_KEY = "this-setting-is-strange";
